import React, { useMemo } from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

const Logo = ({ className, onClick, forceTheme, ...props }) => {
  const { theme } = useTheme();

  const logoSrc = useMemo(() => {
    // Allow overriding the theme (e.g. for dark footer on light mode)
    if (props.forceTheme) {
      return props.forceTheme === "dark" ? "/logo-dark.svg" : "/logo-light.svg";
    }
    const isDark =
      theme === "dark" || document.documentElement.classList.contains("dark");
    return isDark ? "/logo-dark.svg" : "/logo-light.svg";
  }, [theme, props.forceTheme]);

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={cn(
        "inline-block h-8 w-auto",
        onClick && "cursor-pointer hover:opacity-80",
        className,
      )}
      onClick={handleClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      {...props}
    >
      <img
        src={logoSrc}
        alt="TeamTab - Expense Splitting for Teams"
        className="h-8 w-auto transition-opacity duration-200 pointer-events-none"
        loading="lazy"
      />
    </div>
  );
};

export default Logo;
